import { apiGet, apiPost } from "./apiClient";
import { createCachedFetcher } from "./cachedFetcher";

const fetchAgentsRaw = createCachedFetcher(
  // Response is { data: { all_agents: [...], online_count } } — the agent
  // array moved one level deeper than before; only online_count is new,
  // and it isn't needed here (derivable from all_agents itself if ever
  // required).
  () => apiPost("/wati_messages/get_all_agents", {}).then(res => {
    if (!res.data?.success) return [];
    return [...(res.data.data?.all_agents || [])]
      .sort((a, b) => ((b.online || b.isBot) - (a.online || a.isBot)) || a.fullName.localeCompare(b.fullName));
  }),
  { fallback: [] }
);

export function fetchAgents({ force = false } = {}) {
  return fetchAgentsRaw(undefined, { force });
}

const fetchSrmUsersRaw = createCachedFetcher(
  () => apiGet("/whatsapp/get_users").then(res => {
    if (!res.data?.success) return [];
    return (res.data.data || [])
      .map(u => ({ id: u.id, fullName: u.name }))
      .sort((a, b) => a.fullName.localeCompare(b.fullName));
  }),
  { fallback: [] }
);

export function fetchSrmUsers({ force = false } = {}) {
  return fetchSrmUsersRaw(undefined, { force });
}
